export default __webpack_public_path__ + "assets/icons/logo_black.25eea09c.svg";